import { render, staticRenderFns } from "./fontSize-editor.vue?vue&type=template&id=27111335&scoped=true&"
import script from "./fontSize-editor.vue?vue&type=script&lang=js&"
export * from "./fontSize-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27111335",
  null
  
)

export default component.exports